export default __webpack_public_path__ + "static/media/atlas-landscape-white.ef4a3ceb.svg";